export const whitelistWebhooks = {
  integrations: {
    All: false,
    Webhooks: true,
  },
}

export const blacklistWebhooks = {
  integrations: {
    Webhooks: false,
  },
}

export const userSensitiveData = {
  integrations: {
    'Facebook Pixel': false,
    Webhooks: false,
  },
}

export const integrations = {
  adwords: 'adwords',
  facebookPixel: 'facebook-pixel',
  googleAnalytics: 'google-analytics',
  googleTagManager: 'google-tag-manager',
  hubspot: 'hubspot',
  media: 'media',
}

export const integrationsToDisplayName = {
  [integrations.adwords]: 'Google Ads (Classic)',
  [integrations.facebookPixel]: 'Facebook Pixel',
  [integrations.googleAnalytics]: 'Google Analytics',
  [integrations.googleTagManager]: 'Google Tag Manager',
  [integrations.hubspot]: 'HubSpot',
  [integrations.media]: 'Media',
}

export const categoryMap = {
  marketing: [
    integrationsToDisplayName[integrations.adwords],
    integrationsToDisplayName[integrations.facebookPixel],
    integrationsToDisplayName[integrations.googleTagManager],
    integrationsToDisplayName[integrations.hubspot],
  ],
  analytics: [integrationsToDisplayName[integrations.googleAnalytics]],
  media: [integrationsToDisplayName[integrations.media]],
}

export const validScriptIntegrations = [
  integrationsToDisplayName[integrations.adwords],
  integrationsToDisplayName[integrations.facebookPixel],
  integrationsToDisplayName[integrations.googleAnalytics],
  integrationsToDisplayName[integrations.googleTagManager],
  integrationsToDisplayName[integrations.hubspot],
]

export const activeIntegrations = {
  [integrations.adwords]: true,
  [integrations.facebookPixel]: true,
  [integrations.googleAnalytics]: true,
  [integrations.googleTagManager]: true,
  [integrations.hubspot]: true,
}
